import { ArraySerializer, Field, Model, Type } from 'serialize-ts';
import { ProductAttribute, ProductAttributeSPD } from './product-attribute.model';
import { ModelMetadataSerializer } from 'serialize-ts/dist/serializers/model-metadata.serializer';

@Model()
export class ProductAttributeDetails {

  @Field()
  caption: string;

  @Field()
  highlightsPriority?: string;

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(ProductAttribute)))
  attributes: ProductAttribute[];

}

@Model()
export class ProductAttributeDetailsSPD {

  @Field()
  caption: string;

  @Field()
  highlightsPriority?: string;

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(ProductAttributeSPD)))
  attributes: ProductAttributeSPD[];

}
